export default "__VITE_ASSET__8e0f19a0__"